import {
  createCheckInApi,
  getAllAttendanceApi,
  deleteCheckInApi,
  getAttendanceDetailByIdApi,
  updateCheckInApi,
  startBreakApi,
  endBreakApi,
  checkInNowApi,
  checkOutNowApi,
} from "../../api/attendance";
import { toast } from "react-toastify";
import { CHECKIN_ACTION_TYPES, CHECKIN_REQUEST } from "../utilities";

export const createCheckIn =
  (attendanceData, navigate) => async (dispatch, getState) => {
    dispatch({ type: CHECKIN_ACTION_TYPES.CREATE_CHECKIN_REQUEST });

    const token = getState().user?.user?.token;
    if (!token) {
      return;
    }

    try {
      const { data } = await createCheckInApi(attendanceData, token);
      if (data.succeeded) {
        dispatch({
          type: CHECKIN_ACTION_TYPES.CREATE_CHECKIN_SUCCESS,
          payload: data.data,
        });
        toast.success(data.message || "Check-in created successfully!");
        if (navigate) {
          navigate(attendanceData);
        }
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch({
        type: CHECKIN_ACTION_TYPES.CREATE_CHECKIN_FAILURE,
        payload: message,
      });
      toast.error(message);
    }
  };

export const getAllAttendance = (filters) => async (dispatch, getState) => {
  dispatch({ type: CHECKIN_REQUEST.GET_ALL_CHECKINS_REQUEST });
  const token = getState().user?.user?.token;
  if (!token) {
    const errorMsg = "Token not found, please login again.";
    dispatch({
      type: CHECKIN_REQUEST.GET_ALL_CHECKINS_FAILURE,
      payload: errorMsg,
    });
    return;
  }
  try {
    const { data } = await getAllAttendanceApi(filters, token);
    if (data.succeeded) {
      dispatch({
        type: CHECKIN_REQUEST.GET_ALL_CHECKINS_SUCCESS,
        payload: data.data,
      });
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: CHECKIN_REQUEST.GET_ALL_CHECKINS_FAILURE,
      payload: message,
    });
  }
};

export const deleteCheckIn = (id) => async (dispatch, getState) => {
  dispatch({ type: CHECKIN_REQUEST.DELETE_CHECKIN_REQUEST });
  const token = getState().user?.user?.token;
  if (!token) {
    return;
  }
  try {
    const { data } = await deleteCheckInApi(id, token);
    if (data.succeeded) {
      dispatch({ type: CHECKIN_REQUEST.DELETE_CHECKIN_SUCCESS, payload: id });
      toast.success(data.message || "Record deleted successfully!");
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({
      type: CHECKIN_REQUEST.DELETE_CHECKIN_FAILURE,
      payload: message,
    });
    toast.error(message);
  }
};

// export const getAttendanceDetailById = (id ,token ) => async (dispatch, getState) => {
//   dispatch({ type: CHECKIN_REQUEST.GET_CHECKIN_REQUEST });

//   try {
//     const { data } = await getAttendanceDetailByIdApi(id, token);
//     if (data.succeeded) {
//       dispatch({ type: CHECKIN_REQUEST.GET_CHECKIN_SUCCESS, payload: data.data });
//     } else {
//       throw new Error(data.message);
//     }
//   } catch (error) {
//     const message = error.response?.data?.message || error.message;
//     dispatch({ type: CHECKIN_REQUEST.GET_CHECKIN_FAILURE, payload: message });
//     toast.error(message);
//   }
// };

export const getAttendanceDetailById = (id) => async (dispatch, getState) => {
  dispatch({ type: CHECKIN_REQUEST.GET_CHECKIN_REQUEST });

  const token = getState().user?.user?.token;
  if (!token) {
    const errorMsg = "Not authorized, no token";
    dispatch({ type: CHECKIN_REQUEST.GET_CHECKIN_FAILURE, payload: errorMsg });
    toast.error(errorMsg);
    return;
  }

  try {
    const { data } = await getAttendanceDetailByIdApi(id, token);
    if (data.succeeded) {
      dispatch({
        type: CHECKIN_REQUEST.GET_CHECKIN_SUCCESS,
        payload: data.data,
      });
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message;
    dispatch({ type: CHECKIN_REQUEST.GET_CHECKIN_FAILURE, payload: message });
    toast.error(message);
  }
};
export const updateCheckIn =
  (id, updatedData, navigate) => async (dispatch, getState) => {
    dispatch({ type: CHECKIN_REQUEST.UPDATE_CHECKIN_REQUEST });
    const token = getState().user?.user?.token;
    if (!token) return;

    try {
      const { data } = await updateCheckInApi(id, updatedData, token);
      if (data.succeeded) {
        dispatch({
          type: CHECKIN_REQUEST.UPDATE_CHECKIN_SUCCESS,
          payload: data.data,
        });
        toast.success(data.message || "Record updated successfully!");
        if (navigate) navigate("/all-check");
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      dispatch({
        type: CHECKIN_REQUEST.UPDATE_CHECKIN_FAILURE,
        payload: message,
      });
      toast.error(message);
    }
  };


export const checkInNow = () => async (dispatch, getState) => {
  const token = getState().user?.user?.token;
  const userId = getState().user?.user?.id;

  if (!token || !userId) {
    toast.error("Authentication error. Please log in again.");
    return Promise.reject("Authentication error"); 
  }

  const payload = {
    userId: userId,
  };

  try {
    const { data } = await checkInNowApi(payload, token);
    if (data.succeeded) {
      toast.success("Checked In Successfully!");
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    const message = error.response?.data?.message || "Failed to check in.";
    toast.error(message);
    throw error;
  }
};
export const checkOutNow = () => async (dispatch, getState) => {
  const token = getState().user?.user?.token;
  const userId = getState().user?.user?.id;

  if (!token || !userId) {
    toast.error("Authentication error. Please log in again.");
    return Promise.reject("Authentication error");
  }

  const payload = {
    userId: userId,
  };

  try {
    const { data } = await checkOutNowApi(payload, token);
    if (data.succeeded) {
      toast.success("Checked Out Successfully!");
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    const message = error.response?.data?.message || "Failed to check out.";
    toast.error(message);
    throw error;
  }
};

export const startBreak = () => async (dispatch, getState) => {
  const token = getState().user?.user?.token;
  if (!token) {
    toast.error("You are not logged in.");
    return;
  }

  try {
    const { data } = await startBreakApi(token);
    if (data.succeeded) {
      toast.success("Break started successfully!");
      return data.data;
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    const message = error.response?.data?.message || "Failed to start break.";
    toast.error(message);
    throw error;
  }
};

export const endBreak = () => async (dispatch, getState) => {
  const token = getState().user?.user?.token;
  if (!token) {
    toast.error("You are not logged in.");
    return;
  }

  try {
    const { data } = await endBreakApi(token);
    if (data.succeeded) {
      toast.success("Break ended successfully!");
      return data.data;
    } else {
      throw new Error(data.message);
    }
  } catch (error) {
    const message = error.response?.data?.message || "Failed to end break.";
    toast.error(message);
    throw error;
  }
};
